import { CursorPaginatedResponseSchema, DefaultCursorPageSchema } from 'notable-common';
import { z } from 'zod';
import { OrganizationSchema } from './read.js';
/**
 * The name search and page the organization list accepts.
 *
 * No `sort`: results come back ordered by name.
 */
export const OrganizationListQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .optional()
        .describe('Return only organizations whose name contains this text, case-insensitively.'),
    page: DefaultCursorPageSchema,
})
    .strict();
export const OrganizationListEntrySchema = OrganizationSchema.pick({ id: true, name: true });
/** One page of organizations ordered by name, in the envelope every cursor-paginated route returns. */
export const OrganizationListResponseSchema = CursorPaginatedResponseSchema(OrganizationListEntrySchema);
//# sourceMappingURL=list.js.map